var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"placeholder-image",attrs:{"src":require("@/assets/images/garden-placeholder.png"),"alt":"Place holder"}})}
var staticRenderFns = []

export { render, staticRenderFns }